import { IActivity } from '@sdk/contracts';
import { Button, Divider } from 'antd';
import { useTranslation } from 'react-i18next';

import { ActivityItem } from './ActivityItem';
import { Wrapper } from './ComplementaryMaterialActivities.styles';

import { Icon } from '@/components/Icon';
import { useComplementaryMaterialForm, useCurrentSection, useProfile } from '@/store';

type Props = {
  sectionId: string;
  activities: IActivity[];
};

export const ComplementaryMaterialActivities: React.FC<Props> = ({ sectionId, activities }) => {
  const { t } = useTranslation('CourseTranslations');
  const { setIsOpen } = useComplementaryMaterialForm();
  const { setCurrentSectionId } = useCurrentSection();
  const {
    roleCheck: { isManager, isTeacher }
  } = useProfile();
  const canEdit = isManager || isTeacher;

  return (
    <Wrapper>
      {activities.map(activity => (
        <ActivityItem key={activity._id} sectionId={sectionId} activity={activity} />
      ))}
      {canEdit && (
        <>
          <Divider dashed />
          <Button
            block
            type="primary"
            onClick={() => {
              setCurrentSectionId(sectionId);
              setIsOpen(true);
            }}
            icon={<Icon i="AddAlt" />}>
            {t('ADD_MATERIAL')}
          </Button>
        </>
      )}
    </Wrapper>
  );
};
